import expandIconSrc from '@corbado/shared-ui/assets/expand.svg';
import { memo, useRef } from 'react';
import React from 'react';
import { useIconWithTheme } from '../../../hooks/useIconWithTheme';
import { Icon } from './Icon';
export const ExpandIcon = memo(props => {
    const svgRef = useRef(null);
    const { logoSVG } = useIconWithTheme(svgRef, expandIconSrc);
    return (React.createElement(Icon, { src: logoSVG, ref: svgRef, alt: 'expand-icon', ...props }));
});
